<template>
  <div class="card maturityR">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col cyan">
              <h3><i class="fas fa-exclamation-triangle"></i>Capital Risk</h3>
            </div>
            <div class="text-right">
              <!-- <a href="#" class="moreinfo"><i class="fas fa-chevron-circle-right"></i> More Info</a> -->
            </div>
        </div>
      </div>
      <div class="card-body">
        <div class="chart">
           <canvas id="capitalRiskChart"></canvas>
        </div>

        <!-- <img src="../../../../assets/img/02.png" class="img-fluid" style="margin-bottom: 8px;"> -->


      </div>
  </div>
</template>
<script>
import authService from "@/authService";
//import axios from "axios";
import config from "@/config";
import chartConstants from "@/chartConstants";
// import Chart from "chart.js";
export default {
  name: "capitalrisk",
  data() {
    return {
      accessToken : null,
      capitalChartOptions: chartConstants.maturityBarChartDefault,
      capitalRiskData: {},
      myChart : null

    };
  },
  methods: {
    getCapitalRisk(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/capital-risk",
            auth
        )
        .then(result => {
          this.capitalRiskData = result.data;
          this.setCapitalRiskChart();
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    setCapitalRiskChart() {
      // var labels = [];
      // var dataList = [];
      this.capitalChartOptions.options ={
                              scales: {
                                yAxes: [{
                                  ticks: {
                                    beginAtZero: true,
                                    userCallback: function(label) {
                                      // when the floored value is the same as the value we have a whole number
                                      if (Math.floor(label) === label) {
                                          return label;
                                      }

                                  },
                                  },
                                  scaleLabel: {
                                    display: true,
                                    labelString: 'Par Value'
                                  }

                                }],
                                xAxes: [{
                                  gridLines: {
                                    color: "rgba(0, 0, 0, 0)",
                                  },
                                  scaleLabel: {
                                    display: true,
                                    labelString: 'Trader'
                                  }

                                }, ]
                              },
                              legend: {
                                display: false
                              },
                              plugins: {
                                labels: {
                                  render: function () {
                                    return '';
                                  },
                                }
                              } 
                            }
      this.capitalChartOptions.data.labels = this.capitalRiskData.map((x) => { return x.traderName });
      this.capitalChartOptions.data.datasets[0].data = this.capitalRiskData.map((x) => { return x.bidsQuantity });
      if(this.myChart){
        this.myChart.destroy();
      }
      const ctx = document.getElementById("capitalRiskChart");
      this.myChart = new window.Chart(ctx, {
        type: this.capitalChartOptions.type,
        data: this.capitalChartOptions.data,
        options: this.capitalChartOptions.options
      });
    },
  },
  mounted() {
  this.$cognitoAuth.getIdToken((err, result) => {
    if (err) {
      console.log("accessToken is not found", err);
    } else {
      this.accessToken = result;
      this.getCapitalRisk();
    }
    }); 
  }
};
</script>